export default { release:'26.04.0-MASTER-20251231-020144' }
